const TYPES = ["video/webm;codecs=vp8,opus", "video/webm", "video/mp4"];
const AUDIO_TYPES = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"];

// Records the candidate's camera plus a mix of their mic and the AI's voice. setRemote() swaps the AI track after a reconnect.
export function createMixedRecorder(camStream, micStream) {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  const ctx = new Ctx();
  const dest = ctx.createMediaStreamDestination();
  ctx.createMediaStreamSource(micStream).connect(dest);
  const aiBus = ctx.createGain();
  aiBus.connect(dest);
  let aiSrc = null;
  const video = camStream?.getVideoTracks() || [];
  const mimeType = (video.length ? TYPES : AUDIO_TYPES).find((t) => window.MediaRecorder?.isTypeSupported?.(t)) || "";
  const rec = new MediaRecorder(new MediaStream([...video, ...dest.stream.getAudioTracks()]), { ...(mimeType && { mimeType }), videoBitsPerSecond: 600000, audioBitsPerSecond: 64000 });
  const chunks = [];
  rec.ondataavailable = (e) => { if (e.data?.size) chunks.push(e.data); };
  const t0 = Date.now();
  rec.start(1000);
  return {
    setRemote(stream) {
      try { aiSrc?.disconnect(); } catch { /* gone */ }
      aiSrc = ctx.createMediaStreamSource(stream);
      aiSrc.connect(aiBus);
    },
    stop: () => new Promise((resolve) => {
      const done = () => { ctx.close().catch(() => {}); resolve({ blob: new Blob(chunks, { type: rec.mimeType || mimeType || "video/webm" }), ms: Date.now() - t0 }); };
      if (rec.state === "inactive") { done(); return; }
      rec.onstop = done;
      rec.stop();
    }),
    resume: () => ctx.resume(),
  };
}
